import type { TeamBasic } from '@y-sports/api-client/generated-next-management/src/models';

/** The tournament summary endpoint retains snake_case fields for compatibility. */
export function normalizePublicTournamentTeam(value: Record<string, unknown>): TeamBasic {
  const team = { ...value };
  const fields = ['clubName', 'categoryId', 'categoryName', 'homeColor', 'awayColor', 'goalkeeperColor', 'playersCount', 'officialsCount', 'receiptUploaded'];
  for (const field of fields) {
    const snakeCase = field.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
    team[field] = team[field] ?? team[snakeCase];
  }
  return team as TeamBasic;
}
